<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
			<v-tabs
				app
				show-arrows
				:height="32"
				class="tabs-route"
				background-color="transparent"
				slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/leads/' + id + '/'}" key="leads">{{$trans('lead')}}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/leads/' + id + '/contacts' }" key="contacts" v-if="$store.getters.checkModelPermissions('companycontact')">{{$trans('contacts')}}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/leads/' + id + '/opportunities' }" key="opportunities" v-if="$store.getters.checkModelPermissions('opportunity')">{{$trans('opportunities')}}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/leads/' + id + '/quotations' }" key="quotations" v-if="$store.getters.checkModelPermissions('quotation')">{{$trans('quotations')}}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/leads/' + id + '/projects' }" key="projects" v-if="$store.getters.checkModelPermissions('project')">{{$trans('projects')}}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/leads/' + id + '/assets' }" key="assets" v-if="$store.getters.checkModelPermissions('asset')">{{$trans('assets')}}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/leads/' + id + '/tickets' }" key="tickets" v-if="$store.getters.checkModelPermissions('trouble')">{{$trans('tickets')}}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/leads/' + id + '/taskboard' }" key="taskboard" v-if="$store.getters.checkSettings('leads_task')">{{$trans('taskboard')}}</v-tab>
			</v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>

        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'lead-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                model: {},
            }
        },

        computed: {
            entityTitle()  {
                return this.model.id ? ['code', 'business_name'].reduce((acc, key) => this.model[key] ? acc.concat(this.model[key]) : acc, []).join(' - ') : ''
            }
        },

        created() {
            this.$store.commit('endProgress')
            this.axios.get('leads/' + this.id + '?&lite=1').then(response => {
                this.model = response.data.model
            }, response => {
                // error callback
            })
        },
    }
</script>
